/* assets/yc-quiz.js : le moteur de TOUS les quiz produit « Le quiz du PDG » (litières, pompes, …).
   Règles d'écriture et de calibrage : yumi-boutique/data/quiz/CHARTE-QUIZ-PRODUIT.md (elle fait foi).
   Un quiz = un fichier de données assets/yc-quiz-donnees-<id>.js, ÉCRIT par yumi-boutique/scripts/quiz.py depuis
   yumi-boutique/data/quiz/quiz-<id>.json (seule source : produits, questions, notes, atouts, avec leurs preuves).
   Ce même fichier est rejoué sans navigateur par quiz.py (node) : le calcul contrôlé est celui que voit le visiteur.
   Monté par snippets/yc-quiz.liquid, qui écrit EN DIRECT le prix, la photo, la variante et la disponibilité de chaque
   produit ; le moteur et les données ne se chargent qu'à l'approche du bloc.
   Parcours (maquette 1B4 validée le 09/10/2026) : accroche, barre de progression qui part de 20 % (ses mots ramènent à
   une étape : pas de bouton Retour), une question collée à ses cartes (un Yumi par réponse), et dessous les produits
   avec leur barre en % qui se reclassent à chaque réponse (les 5 premiers seulement : client, 10/10/2026). À la fin :
   le gagnant, « Faite pour vous à … % », le prix (barré et économie quand il y en a), trois atouts reliés aux réponses,
   l'ajout au panier de toute la boutique. Une question peut ne valoir que pour certaines réponses (« si », « sauf »).
   Couleurs devinées (filaments, client 10/10/2026) : un produit peut porter ses teintes (une fiche par couleur, lues en
   direct) ; le résultat montre la bobine de la couleur voulue et, à plusieurs couleurs, « avec » les autres, chacune
   ajoutable au panier. 8 étapes ou plus : la barre défile sur une ligne, l'étape en cours au centre (DATA.defile). */
(function () {
  'use strict';

  /* ---------- une photo qui échoue ne reste jamais cassée (client, 21/10/2026 : miniature cassée sur un résultat) ----------
     Le CDN fabrique la miniature 300 px à la première demande ; un échec passager laissait l'icône d'image cassée.
     On réessaie deux fois avec un paramètre neuf, puis on cache la photo plutôt que d'afficher le symbole. */
  if (typeof window !== 'undefined' && typeof document !== 'undefined' && !window.__ycQuizPhotos) {
    window.__ycQuizPhotos = 1;
    document.addEventListener('error', function (ev) {
      const im = ev.target;
      if (!im || im.tagName !== 'IMG' || !im.closest || !im.closest('.ql2')) return;
      const n = +(im.dataset.re || 0), u = (im.getAttribute('src') || '').replace(/[?&]r=\d+/, '');
      if (!u) { im.style.visibility = 'hidden'; return; }
      if (n < 2) {
        im.dataset.re = n + 1;
        setTimeout(function () { im.setAttribute('src', u + (u.indexOf('?') < 0 ? '?' : '&') + 'r=' + Date.now()); }, 600 * (n + 1));
      } else im.style.visibility = 'hidden';
    }, true);
    document.addEventListener('load', function (ev) {
      const im = ev.target;
      if (im && im.tagName === 'IMG' && im.style.visibility === 'hidden' && im.closest && im.closest('.ql2')) im.style.visibility = '';
    }, true);
  }

  /* ---------- mesure : combien de visiteurs jouent aux quiz ? (client, 21/10/2026) ----------
     Événements Google Analytics 4 de la boutique (même flux que le canal Google) : quiz_demarre, quiz_reponse (étape),
     quiz_resultat, quiz_clic_produit, quiz_panier ; la fiche où se joue le quiz est dans page_location, le quiz dans
     quiz_id. Rien n'est envoyé : sans l'accord « statistiques » du visiteur (le même que celui des pages vues) ;
     depuis un navigateur piloté (mes essais) ; depuis un thème en aperçu ; depuis un appareil marqué « interne » :
     ouvrir UNE fois n'importe quelle page de la boutique avec ?yc_interne=1 (retrait : ?yc_interne=0). */
  const GA = 'G-D9XTP5Y2W0';
  function interne() {
    try {
      if (/[?&]yc_interne=1\b/.test(location.search)) localStorage.setItem('yc_interne', '1');
      if (/[?&]yc_interne=0\b/.test(location.search)) localStorage.removeItem('yc_interne');
      return navigator.webdriver === true || localStorage.getItem('yc_interne') === '1'
        || /[?&]preview_theme_id=/.test(location.search) || !!(window.Shopify && window.Shopify.designMode);
    } catch (e) { return navigator.webdriver === true; }
  }
  function accord(fin) {
    const ok = () => { const c = window.Shopify && window.Shopify.customerPrivacy; return !!(c && c.analyticsProcessingAllowed && c.analyticsProcessingAllowed()); };
    if (ok()) { fin(true); return; }
    if (!(window.Shopify && window.Shopify.loadFeatures)) { fin(false); return; }
    try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], err => fin(!err && ok())); } catch (e) { fin(false); }
  }
  let gaPret = false;
  function mesurer(quiz, nom, p) {
    if (interne()) return;
    accord(ok => {
      if (!ok) return;
      if (!gaPret) {
        gaPret = true;
        window.dataLayer = window.dataLayer || [];
        window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
        window.gtag('js', new Date());
        window.gtag('config', GA, { send_page_view: false });
        const s = document.createElement('script');
        s.async = true; s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA;
        document.head.append(s);
      }
      window.gtag('event', nom, Object.assign({ quiz_id: quiz }, p || {}));
    });
  }

  /* ---------- calcul (pur) ---------- */
  function moteur(DATA) {
    const RANG = { aucune: 0, couleur: 0.5, douce: 1, forte: 2 };
    const qi = Object.fromEntries(DATA.questions.map((Q, i) => [Q.id, i]));
    const euro = n => (Math.round(n * 100) / 100).toFixed(2).replace('.', ',') + ' €';
    const pluriel = rep => !!(DATA.pluriel && DATA.pluriel.reponses.includes(rep[DATA.pluriel.question]));
    const forme = (t, n) => Array.isArray(t) ? t[n ? 1 : 0] : t;
    // une question « si » ne vaut que si la réponse qu'elle attend a été donnée (ex. le vélo, seulement pour un cycliste) ;
    // une question « sauf » tombe si l'une des réponses citées a été donnée (ex. pas de couleur à deviner pour une
    // bobine multicolore)
    const vaut = (Q, rep) => (!Q.si || Object.entries(Q.si).every(([q, ids]) => rep[q] != null && ids.includes(rep[q])))
      && (!Q.sauf || !Object.entries(Q.sauf).some(([q, ids]) => rep[q] != null && ids.includes(rep[q])));
    const reponse = (Q, rep) => (vaut(Q, rep) && rep[Q.id] != null) ? Q.reponses.find(r => r.id === rep[Q.id]) : null;
    function palier(prix, plafond) {
      const ecart = 100 * (prix - plafond) / plafond;
      return DATA.budget.paliers.find(p => p.ecart_max_pct === null || ecart <= p.ecart_max_pct);
    }
    function actifs(rep) {
      const crit = [], contr = {};
      let plafond = null;
      for (const Q of DATA.questions) {
        const R = reponse(Q, rep);
        if (!R) continue;
        (R.criteres || []).forEach(c => crit.push(c));
        Object.entries(R.contraintes || {}).forEach(([id, f]) => { if (RANG[f] > RANG[contr[id] || 'aucune']) contr[id] = f; });
        if (R.budget) plafond = R.budget;
      }
      return { crit, contr, plafond };
    }
    /* Les couleurs devinées (client, 10/10/2026 : « s'il tombe sur du blanc mais qu'en fait il voulait du rouge, notre
       quiz n'est pas bon »). Un produit peut porter ses teintes : { h (fiche), nom, g (groupes de couleur), proposable }
       — sur le site, « proposable » est relu EN DIRECT par le snippet (une teinte en rupture n'est jamais proposée).
       Les réponses disent : nb_couleurs (1, 2, 3 ou plus), palette (les couleurs d'un groupe), couleur (la principale). */
    function envies(rep) {
      let k = 0, palette = [], main = null;
      for (const Q of DATA.questions) {
        const R = reponse(Q, rep);
        if (!R) continue;
        if (R.nb_couleurs) k = R.nb_couleurs;
        if (R.palette) palette = R.palette;
        if (R.couleur) main = R.couleur;
      }
      if (!k || (!main && !palette.length)) return null;
      const voulu = k === 1 ? [main] : (main ? [main] : []).concat(palette.filter(g => g !== main));
      return { k, main, voulu };
    }
    const teintes = L => (L.teintes || []).filter(t => t.proposable !== false);
    // la part des couleurs voulues que ce produit a en stock ; la principale absente = contrainte douce (le quiz
    // préfère un filament qui l'a, sauf contrainte technique plus forte)
    function couleur(rep, L) {
      const e = envies(rep);
      if (!e || !DATA.couleurs) return null;
      const a = new Set(teintes(L).flatMap(t => t.g)), besoin = Math.min(e.k, e.voulu.length);
      const autres = e.voulu.filter(g => g !== e.main && a.has(g)).length;
      let fit, c = null;
      if (e.main) {
        const ok = a.has(e.main);
        fit = ((ok ? 1 : 0) + Math.min(besoin - 1, autres)) / besoin;
        if (!ok) c = 'douce';
      } else {
        fit = Math.min(besoin, autres) / besoin;
        if (!autres) c = 'douce';
      }
      return { fit, c };
    }
    /* les bobines du résultat : la principale dans la couleur voulue, puis « avec » 1 ou 2 autres couleurs voulues du
       même produit (seulement quand il en veut plusieurs) */
    function bobines(rep, L) {
      const e = envies(rep), T = teintes(L);
      if (!e || !T.length) return { tete: null, avec: [], k: e ? e.k : 0 };
      const pour = g => T.find(t => t.g.includes(g));
      const pris = [];
      e.voulu.forEach(g => { const t = pour(g); if (t && !pris.includes(t)) pris.push(t); });
      // la principale absente de ce produit : on montre d'abord une autre couleur voulue, jamais une couleur au hasard
      const tete = (e.main && pour(e.main)) || pris[0] || null;
      return { tete, avec: e.k > 1 ? pris.filter(t => t !== tete).slice(0, 2) : [], k: e.k };
    }
    /* Calibrage (charte § 3 bis) : les CONTRAINTES choisissent l'échelle (aucune 70-99 %, douce 52-72 %, forte 35-55 %),
       les PRÉFÉRENCES placent le produit dans l'échelle ; le premier au moins à 76 %, au moins 9 points entre le 1er et
       le 2e et entre le 2e et le 3e. Le budget est surtout une limite ; il ne compte qu'un peu (poids le plus faible).
       À égalité : le plus d'atouts reliés aux réponses, puis le mieux équipé (prix le plus haut). */
    function calculer(rep, liste) {
      const P = liste || DATA.produits.filter(L => L.proposable !== false);
      const { crit, contr, plafond } = actifs(rep), E = DATA.calibrage.echelles;
      if (!Object.keys(rep).length) return P.map(L => ({ L, v: null, pct: null, c: 'aucune' }));
      let res = P.map(L => {
        let sw = 0, sn = 0, c = contr[L.id] || 'aucune';
        crit.forEach(([k, w]) => { sw += w; sn += w * DATA.criteres[k][L.id]; });
        const C = couleur(rep, L);
        if (C) {
          sw += DATA.couleurs.poids; sn += DATA.couleurs.poids * C.fit;
          // la couleur passe APRÈS l'usage (projet, rendu, imprimante) : sans elle, un produit qui convient descend d'une
          // marche (échelle « couleur », sous « aucune » et au-dessus de « douce ») ; déjà contraint, il le reste
          if (C.c && c === 'aucune') c = E.couleur ? 'couleur' : C.c;
        }
        if (plafond) {
          const p = palier(L.prix, plafond), marge = (plafond - L.prix) / plafond;
          if (p.contrainte && RANG[p.contrainte] > RANG[c]) c = p.contrainte;
          sw += DATA.budget.poids; sn += DATA.budget.poids * (marge >= 0 ? 0.75 + 0.25 * Math.min(1, marge / 0.3) : 0.4);
        }
        const fit = sw ? sn / sw : 1, [lo, hi] = E[c];
        const v = (lo + (hi - lo) * fit) / 100;
        return { L, v, pct: Math.round(100 * v), c, cu: contr[L.id] || 'aucune', fit, n: atouts(rep, L).length };
      }).sort((a, b) => (Math.round(1e6 * b.v) - Math.round(1e6 * a.v)) || b.n - a.n || b.L.prix - a.L.prix);
      // une couleur choisie : un produit qui ne l'a pas n'apparaît pas (client, 10/10/2026 : « ça ne correspond pas à ce
      // que le client a choisi »), sauf si AUCUN produit adapté à l'usage ne l'a (pas de TPU rose) : on garde alors le
      // classement, et le résultat dit « pas en rose pour l'instant »
      const ev = DATA.couleurs ? envies(rep) : null;
      if (ev && ev.main) {
        const a = x => teintes(x.L).some(t => t.g.includes(ev.main));
        // « adapté à l'usage » : sans contrainte forte venue des réponses (le budget ne compte pas : un TPU violet un peu
        // au-dessus du budget passe avant un TPU noir)
        if (res.some(x => a(x) && x.cu !== 'forte')) res = res.filter(a);
      }
      const min = DATA.calibrage.gagnant_min / 100, ecart = DATA.calibrage.ecart_min;
      if (res[0].v < min) { res[0].v = min; res[0].pct = Math.round(100 * min); }
      // des écarts nets pour aider à décider : au moins « ecart » points entre le 1er et le 2e, et le 2e et le 3e ;
      // ensuite, parmi ceux qu'on voit, jamais deux au même pourcentage (client, 10/10/2026 : « pas trois qui tombent
      // sur le même pourcentage ») : « ecart_suite » points, sans descendre sous 35 %
      const suite = DATA.calibrage.ecart_suite || 0, vus = DATA.affiche || 5;
      for (let i = 1; i < res.length; i++) {
        const pas = i <= 2 ? ecart : (i < vus ? suite : 0);
        const plafondI = Math.max(i <= 2 ? -Infinity : 35, res[i - 1].pct - pas);
        if (res[i].pct > plafondI) { res[i].pct = plafondI; res[i].v = plafondI / 100; }
      }
      return res;
    }
    /* remise affichée (PRIX-ET-FRAIS.md § 2, comme snippets/yc-remise.liquid) : rien sous 1 % de remise réelle ;
       à partir de 100 € de référence en euros avec centimes, en dessous en pourcentage arrondi */
    function remise(L) {
      if (!L.prix_barre || L.prix_barre <= L.prix) return null;
      const pct = 100 * (1 - L.prix / L.prix_barre);
      if (pct < 1) return null;
      return { pct, txt: L.prix_barre < 100 ? Math.round(pct) + ' %' : euro(L.prix_barre - L.prix) };
    }
    /* les 3 atouts du gagnant (charte § 4) : seulement ceux qu'il a vraiment ET qu'une réponse donnée déclenche ;
       force décroissante, ordre des questions, ordre de la table ; d'abord un atout fort par réponse, puis les autres */
    // « \b » de JavaScript ignore les lettres accentuées (« écran » n'était jamais reconnu) : on le remplace par une limite
    // de mot Unicode ; un navigateur trop ancien pour la comprendre garde l'expression d'origine
    const MOT = DATA.mot_fort ? (() => {
      const LIM = String.raw`(?:(?<=[\p{L}\p{N}])(?![\p{L}\p{N}])|(?<![\p{L}\p{N}])(?=[\p{L}\p{N}]))`;
      try { return new RegExp(DATA.mot_fort.replace(/\\b/g, LIM), 'iu'); }
      catch (e) { return new RegExp(DATA.mot_fort, 'i'); }
    })() : null;
    function atouts(rep, L) {
      const n = pluriel(rep), { plafond } = actifs(rep);
      const cand = [];
      DATA.atouts.forEach((A, t) => {
        if (!A.produits.includes(L.id)) return;
        const marge = plafond ? 100 * (plafond - L.prix) / plafond : -1;
        if (A.condition === 'marge' && !(marge >= A.marge_min_pct)) return;
        if (A.condition === 'dans_budget_serre' && !(marge >= 0 && marge < 10)) return;
        if (A.condition === 'couleurs') { const C = couleur(rep, L); if (!C || C.fit < 1) return; }
        let best = null;
        Object.entries(A.reponses).forEach(([cle, f]) => {
          const [q, v] = cle.split('.');
          const Q = DATA.questions[qi[q]];
          if (Q && vaut(Q, rep) && rep[q] === v && (!best || f > best.f || (f === best.f && qi[q] < qi[best.q]))) best = { f, q };
        });
        if (best) cand.push({ A, t, f: best.f, q: best.q });
      });
      cand.sort((a, b) => b.f - a.f || qi[a.q] - qi[b.q] || a.t - b.t);
      // jamais deux atouts qui répètent le même mot fort (litières : « chat(s) ») ; en dernier recours seulement
      const txt = c => forme(c.A.texte, n);
      const pris = [], servies = new Set();
      const repete = c => pris.some(x => txt(x) === txt(c)) || (MOT && MOT.test(txt(c)) && pris.some(x => MOT.test(txt(x))));
      cand.forEach(c => { if (pris.length < 3 && c.f >= 2 && !servies.has(c.q) && !repete(c)) { pris.push(c); servies.add(c.q); } });
      const reste = () => cand.filter(c => !pris.includes(c))
        .sort((x, y) => y.f - x.f || servies.has(x.q) - servies.has(y.q) || qi[x.q] - qi[y.q] || x.t - y.t);
      reste().forEach(c => { if (pris.length < 3 && !repete(c)) pris.push(c); });
      reste().forEach(c => { if (pris.length < 3 && !pris.some(x => txt(x) === txt(c))) pris.push(c); });
      pris.sort((x, y) => y.f - x.f || qi[x.q] - qi[y.q] || x.t - y.t); // affichage : le plus fort d'abord
      return pris.map(c => ({ id: c.A.id, q: c.q, t: forme(c.A.texte, n).replace('{marge}', plafond ? euro(plafond - L.prix) : '') }));
    }
    return { DATA, calculer, atouts, remise, pluriel, forme, vaut, euro, bobines, envies };
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { moteur };
  if (typeof document === 'undefined') return;

  /* ---------- la carte ---------- */
  const h = html => { const t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstElementChild; };
  const CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.6l4.3 4.3L19 7.4"/></svg>';
  const FLECHE_D = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12h15"/><path d="M13 6l6 6-6 6"/></svg>';
  const REFAIRE = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12a8 8 0 1 0 2.6-5.9"/><path d="M4 4v4.5h4.5"/></svg>';
  const PANIER = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4h2.5l2.2 11h10.6l2-8H6.6"/><circle cx="9.5" cy="19.5" r="1.4"/><circle cx="17" cy="19.5" r="1.4"/></svg>';
  const H = 52; // hauteur d'une ligne de la liste (46 px + 6 px d'écart)
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* o : { produits (classables, données vivantes), courant (handle de la fiche), image(p) -> adresse,
           panier(L), suivi(L, etat), later, on, tween } */
  function carte(stage, M, o) {
    const DATA = M.DATA, T = DATA.textes, NQ = DATA.questions.length, N = 3;   // trois résultats, jamais plus (client, 21/10/2026) ; « affiche » des données n'est plus lu
    const P = o.produits, url = o.image;
    const rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    const plus = (ms, fn) => (rm ? fn() : o.later(ms, fn));
    const visuel = V => {
      if (V.nb) {
        const pos = V.nb === 1 ? [[50, 1]] : V.nb === 2 ? [[33, .8], [67, .8, 1]] : [[25, .68], [75, .68, 1], [50, .82]];
        return pos.map(([x, s, mi], i) => `<img src="${url(V.img)}" alt="" draggable="false" class="tete" style="left:${x}%;--s:${s};${mi ? '--m:-1;' : ''}z-index:${i === 2 ? 3 : 1}">`).join('');
      }
      return `<img src="${url(V.img)}" alt="" draggable="false" style="--s:${V.echelle || 1}">`;
    };
    // avant la première réponse : la fiche qu'on regarde d'abord, puis l'ordre du quiz
    // (une fiche de couleur compte pour son produit : ses teintes)
    const ici = L => L.handle === o.courant || (L.teintes || []).some(t => t.h === o.courant);
    const depart0 = P.slice().sort((a, b) => ici(b) - ici(a));
    const w = h(`<div class="ql2">
      <div class="ql2-haut"></div>
      <div class="ql2-cl" hidden>
        <div class="ql2-liste" style="height:${Math.min(P.length, N) * H - 6}px">${P.map(L => `<a class="ql2-lg" data-id="${esc(L.id)}" href="${esc(L.url)}" target="_blank" rel="noopener" tabindex="-1"><span class="ph"><img src="${esc(L.image)}" alt=""></span><div class="mid"><div class="n">${esc(L.nom)}<small class="mq"></small></div><div class="j"><i></i></div></div><b class="pc"></b></a>`).join('')}</div>
      </div>
    </div>`);
    stage.append(w);
    const haut = w.querySelector('.ql2-haut'), cl = w.querySelector('.ql2-cl');
    const lignes = Object.fromEntries([...w.querySelectorAll('.ql2-lg')].map(e => [e.dataset.id, e]));
    const placer = (L, i) => { const e = lignes[L.id]; e.style.transform = `translateY(${Math.min(i, N) * H}px)`; e.classList.toggle('cache', i >= N); };
    depart0.forEach(placer);

    let rep = {}, etape = -1, verrou = false, prog = null;
    const valables = () => DATA.questions.map((Q, i) => i).filter(i => M.vaut(DATA.questions[i], rep));
    const suivante = i => valables().find(k => k > i);

    // la liste : position, barre et pourcentage ; seuls les N premiers se voient
    function maj() {
      const res = M.calculer(rep, P), vide = res[0].pct === null;
      let ordre = vide ? depart0.map(L => ({ L, v: null, pct: null })) : res;
      // seulement ce qui convient (client, 10/10/2026) : un produit en contrainte forte (usage, budget très dépassé)
      // quitte la liste, mais il en reste toujours 3 au moins
      if (!vide) {
        const bons = res.filter(x => x.c !== 'forte');
        ordre = bons.length >= 3 ? bons : res.slice(0, Math.min(3, res.length));
      }
      w.querySelector('.ql2-liste').style.height = `${Math.min(Math.max(ordre.length, 1), N) * H - 6}px`;
      const fini = etape >= NQ;
      w.classList.toggle('fini', fini);   // les lignes ne sont cliquables qu'au résultat (client, 21/10/2026)
      const seule = !vide && (fini || !res[1] || Math.round(1e6 * res[0].v) > Math.round(1e6 * res[1].v));
      // pendant le quiz, les pourcentages partent de 50 % et rejoignent le classement final à mesure des réponses
      // (client, 10/10/2026 : « j'ai répondu à quatre ou cinq questions et le pourcentage n'a même pas changé » : les
      // écarts du résultat, 99 / 90 / 81…, s'affichaient dès la 1re réponse et ne bougeaient plus) ; jamais deux
      // pourcentages égaux parmi ceux qu'on voit
      const v = valables(), faits = v.filter(i => rep[DATA.questions[i].id] != null).length;
      const avance = fini ? 1 : Math.min(1, faits / Math.max(1, v.length));
      let avant = 101;
      const vu = ordre.map((x, i) => {
        if (x.pct === null) return null;
        let d = fini ? x.pct : Math.round(50 + (x.pct - 50) * avance);
        if (i < N && d >= avant) d = avant - 1;
        avant = d;
        return d;
      });
      // un produit écarté du classement (pas dans la couleur choisie) quitte la liste
      depart0.forEach(L => { if (!ordre.some(x => x.L === L)) placer(L, N); });
      ordre.forEach((x, i) => {
        const e = lignes[x.L.id];
        placer(x.L, i);
        e.querySelector('.j i').style.transform = `scaleX(${vide ? 0 : vu[i] / 100})`;
        compteur(e.querySelector('.pc'), vu[i]);
        e.classList.toggle('top', seule && i === 0);
        e.tabIndex = fini ? 0 : -1;
        e.classList.toggle('out', !vide && fini && x.pct < 35);
        // la couleur devinée se voit tout de suite : la photo de la ligne passe à la teinte voulue
        if (x.L.teintes) {
          const t = M.bobines(rep, x.L).tete, im = e.querySelector('.ph img'), src = (t && t.image) || x.L.image;
          if (src && im.getAttribute('src') !== src) im.setAttribute('src', src);
          e.setAttribute('href', (t && t.url) || x.L.url);
          // pas dans la couleur voulue : on le dit sur la ligne, jamais une photo d'une autre couleur sans le dire
          // (client, 10/10/2026 : orange demandé, une bobine noire affichée sans un mot)
          const E = M.envies(rep), mq = e.querySelector('.mq');
          mq.textContent = E && E.main && !(t && t.g.includes(E.main)) ? `pas en ${E.main}` : '';
        }
      });
      return res;
    }
    function compteur(el, a) {
      if (a === null) { el.textContent = ''; el._v = 0; return; }
      const de = el._v || 0; el._v = a;
      if (rm || de === a) { el.textContent = a + ' %'; return; }
      o.tween(500, k => { if (el._v === a) el.textContent = Math.round(de + (a - de) * k) + ' %'; }, t => 1 - Math.pow(1 - t, 3));
    }
    function remplacer(nouveau) {
      const ancien = haut.firstElementChild;
      if (ancien && !rm) {
        ancien.classList.add('ql2-sort');
        verrou = true;
        o.later(170, () => { ancien.remove(); haut.append(nouveau); verrou = false; });
      } else { haut.innerHTML = ''; haut.append(nouveau); }
    }

    /* 1. l'accroche : une promesse et un temps, un seul bouton */
    function depart() {
      etape = -1;
      rep = {};
      cl.hidden = true;
      const el = h(`<div class="ql2-depart">
        <img class="yu" src="${url('assets/yumi/yumi-loupe-ouvert.webp')}" alt="">
        <span class="sur">${esc(T.sur)}</span>
        <h5>${esc(T.titre[0])} <span>${esc(T.titre[1])}</span></h5>
        <p>${esc(T.promesse)}</p>
        <button type="button" class="ql2-go">Commencer</button>
        <div class="vitrine">${depart0.slice(0, 6).map(L => `<span><img src="${esc(L.image)}" alt=""></span>`).join('')}</div>
      </div>`);
      remplacer(el);
      o.on(el.querySelector('.ql2-go'), 'click', () => { if (!verrou) { if (o.mesure) o.mesure('quiz_demarre'); question(valables()[0]); } });
    }

    /* 2. la barre : part de 20 %, un mot par étape qui vaut ; les étapes faites ramènent à leur question */
    function barre() {
      if (prog) return prog;
      prog = h(`<div class="ql2-prog${DATA.defile ? ' defile' : ''}">
        <div class="ql2-barre" role="progressbar" aria-valuemin="0" aria-valuemax="100"><i></i></div>
        <div class="ql2-mots"><span class="dep" aria-hidden="true"><i class="patte"></i></span>${DATA.questions.map((Q, i) => `<button type="button" data-i="${i}" disabled>${esc(Q.mot)}</button>`).join('')}</div>
      </div>`);
      // revenir à une étape, c'est reprendre le quiz à cette étape (client, 10/10/2026) : les réponses d'avant restent,
      // celle de l'étape et toutes les suivantes sont effacées (ni cochées, ni comptées dans les pourcentages)
      prog.querySelectorAll('.ql2-mots button').forEach(b => o.on(b, 'click', () => {
        if (verrou) return;
        const i = +b.dataset.i;
        DATA.questions.forEach((Q, k) => { if (k >= i) delete rep[Q.id]; });
        question(i);
      }));
      return prog;
    }
    function majBarre() {
      const v = valables(), k = v.indexOf(etape);
      const p = etape >= NQ ? 100 : 20 + 80 * Math.max(0, k) / v.length;
      prog.querySelector('.ql2-barre i').style.transform = `scaleX(${p / 100})`;
      prog.querySelector('.ql2-barre').setAttribute('aria-valuenow', Math.round(p));
      // 6 étapes et un mot long (« Pression ») : la patte se fait plus étroite et les mots plus petits, sinon ils se
      // touchent sur un téléphone (vu le 10/10/2026 sur le quiz des pompes)
      const mots = prog.querySelector('.ql2-mots');
      if (!DATA.defile) {
        const serre = v.length >= 6 && Math.max(...v.map(i => DATA.questions[i].mot.length)) >= 8;
        mots.classList.toggle('serre', serre);
        mots.style.gridTemplateColumns = `${serre ? 10 : 20}% repeat(${v.length},minmax(0,1fr))`;
      }
      prog.querySelectorAll('.ql2-mots button').forEach((b, i) => {
        const fait = rep[DATA.questions[i].id] != null;
        b.hidden = !v.includes(i);
        b.classList.toggle('ici', i === etape);
        b.classList.toggle('fait', fait && i !== etape);
        b.disabled = !fait || i === etape;
        b.title = fait && i !== etape ? `Revenir à « ${DATA.questions[i].mot} »` : '';
      });
      // 8 étapes et plus (client, 10/10/2026) : les mots tiennent sur UNE ligne qui défile, téléphone comme ordinateur,
      // l'étape en cours toujours au centre (les marges de la ligne permettent de centrer même la première)
      if (DATA.defile) {
        const b = prog.querySelector('.ql2-mots button.ici') || [...prog.querySelectorAll('.ql2-mots button:not([hidden])')].pop();
        const centrer = () => {
          if (!b) return;
          const x = b.offsetLeft - (mots.clientWidth - b.offsetWidth) / 2;
          if (mots.scrollTo) mots.scrollTo({ left: x, behavior: rm ? 'auto' : 'smooth' }); else mots.scrollLeft = x;
        };
        if (prog.isConnected) centrer(); else o.later(0, centrer);
      }
    }

    /* 3 et 4. une question, collée à ses cartes ; pas de sous-titre sous les réponses (client, 10/10/2026 : « pour gagner
       en clarté ») : l'intitulé et l'image de Yumi suffisent */
    function question(i) {
      etape = i;
      const Q = DATA.questions[i], n = M.pluriel(rep), deja = rep[Q.id];
      const el = h(`<div class="ql2-etape">
        <h5 class="ql2-titre">${esc(M.forme(Q.titre, n))}</h5>
        <div class="ql2-cartes${Q.reponses.length > 4 ? ' n4 n5' : Q.reponses.length > 3 ? ' n4' : Q.reponses.length === 2 ? ' n2' : ''}" style="--n:${Q.reponses.length}">${Q.reponses.map((R, k) => `<button type="button" class="ql2-carte${R.id === deja ? ' choisie deja' : ''}" aria-pressed="${R.id === deja}" data-id="${esc(R.id)}" style="animation-delay:${50 + k * 60}ms">
          <span class="ok">${CHECK}</span><span class="vis">${visuel(R.visuel)}</span><span class="tx"><b>${esc(M.forme(R.label, n))}</b></span></button>`).join('')}</div>
      </div>`);
      const pr = barre();
      if (!pr.isConnected) w.insertBefore(pr, haut);
      cl.hidden = false;
      majBarre();
      remplacer(el);
      maj();
      el.querySelectorAll('.ql2-carte').forEach(b => o.on(b, 'click', () => {
        if (verrou) return;
        verrou = true;
        el.querySelectorAll('.ql2-carte').forEach(x => { const on = x === b; x.classList.toggle('choisie', on); x.classList.remove('deja'); x.setAttribute('aria-pressed', on); });
        el.querySelector('.ql2-cartes').classList.add('verrou');
        rep[Q.id] = b.dataset.id;
        if (o.mesure) o.mesure('quiz_reponse', { etape: Object.keys(rep).length });
        majBarre();
        maj();
        // étape suivante, dans l'ordre (client, 09/10/2026 : changer une réponse mène à l'étape suivante, pas au
        // résultat)
        const s = suivante(i);
        plus(rm ? 0 : 700, () => { verrou = false; s != null ? question(s) : fin(); });
      }));
    }

    /* 5. le résultat : la photo dégagée et Yumi à droite, le prix (barré et économie), trois atouts reliés aux réponses */
    function fin() {
      etape = NQ;
      majBarre();
      const res = maj(), g = res[0], at = M.atouts(rep, g.L);
      if (o.mesure) o.mesure('quiz_resultat', { produit: g.L.handle });
      // la bobine de la couleur voulue remplace la fiche qui représente le produit (photo, prix, lien, panier)
      const B = M.bobines(rep, g.L), comme = t => Object.assign({}, g.L, {
        handle: t.h, url: t.url || g.L.url, image: t.image || g.L.image, prix: t.prix != null ? t.prix : g.L.prix,
        prix_barre: t.prix_barre !== undefined ? t.prix_barre : g.L.prix_barre, variante: t.variante || g.L.variante,
        limites: t.limites !== undefined ? t.limites : g.L.limites });
      const tete = B.tete || (g.L.teintes || []).find(t => t.h === g.L.handle);
      const L = B.tete ? comme(B.tete) : g.L, r = M.remise(L), avec = B.avec.map(t => [t, comme(t)]);
      const pastille = t => `<i class="pastille" style="background:${esc(t.hex || '#ccc')}"></i>`;
      // la couleur principale voulue n'existe pas dans ce filament (ou plus en stock) : on le dit, en clair
      const E = M.envies(rep), manque = E && E.main && !(tete && tete.g.includes(E.main)) ? E.main : null;
      // les autres couleurs voulues absentes de ce filament : dites aussi (client, 10/10/2026 : jamais une couleur
      // demandée qui disparaît sans un mot). À 2 couleurs, une seule « avec » suffit ; à 3, chacune compte
      const couvre = g => [tete, ...B.avec].some(t => t && t.g.includes(g));
      const absents = E && B.k > 1 && !(B.k === 2 && B.avec.length) ? E.voulu.slice(1).filter(g => !couvre(g)) : [];
      const pasEn = absents.length ? `<small class="ql2-pasen">Pas en ${esc(absents.join(' ni en '))} dans ce filament pour l’instant</small>` : '';
      const el = h(`<div class="ql2-fin">
        <span class="sur">${esc(T.ideal)}</span>
        <div class="vitre"><a class="ph" href="${esc(L.url)}" target="_blank" rel="noopener"><img src="${esc(L.image)}" alt="${esc(L.nom)}"></a><span class="cote"><img class="yu" src="${url('assets/yumi/yumi-ravi-v3.webp')}" alt=""><a class="fiche" href="${esc(L.url)}" target="_blank" rel="noopener">Voir la fiche${FLECHE_D}</a><button type="button" class="refaire">${REFAIRE}Recommencer</button></span></div>
        <b class="nom"><a href="${esc(L.url)}" target="_blank" rel="noopener">${esc(L.nom)}</a></b>
        ${tete && B.k ? `<span class="teinte">${pastille(tete)}${esc(tete.nom)}${manque ? `<small>pas en ${esc(manque)} pour l’instant</small>` : ''}</span>` : ''}
        <div class="ligne"><span class="score">${esc(T.score)} <b>${g.pct} %</b></span></div>
        <ul>${at.map(a => `<li data-q="${esc(a.q)}"><i class="co">${CHECK}</i><span>${esc(a.t)}</span></li>`).join('')}</ul>
        <div class="prix"><b>${M.euro(L.prix)}</b>${r ? `<s>${M.euro(L.prix_barre)}</s><span class="eco">−${r.txt}</span>` : ''}</div>
        <button type="button" class="ql2-panier" data-yc-vol>${PANIER}<span>Ajouter au panier</span></button>
        ${avec.length ? `<div class="ql2-avec"><span class="t">${esc(B.k === 2 ? (T.avec2 || 'Pour votre 2e couleur') : (T.avec3 || 'Avec, pour vos autres couleurs'))}</span>${avec.map(([t, X]) => `<div class="ql2-av"><span class="vg"><img src="${esc(X.image)}" alt=""></span><span class="n"><span class="l">${pastille(t)}<span>${esc(t.nom)}</span></span><small>${M.euro(X.prix)}</small></span><button type="button" class="ql2-panier mini" data-yc-vol>${PANIER}<span>Ajouter</span></button></div>`).join('')}${pasEn}</div>` : pasEn}
      </div>`);
      remplacer(el);
      // chaque bouton dit ce que contient VRAIMENT le panier (client, 09/10/2026) : o.suivi le rappelle à chaque
      // changement ; une bobine « avec » a le même ajout que toute la boutique (bille, volet)
      const suivis = [[el.querySelector('.ql2-panier:not(.mini)'), L, T.ajoute || 'Ajouté au panier', 'Ajouter au panier']]
        .concat([...el.querySelectorAll('.ql2-panier.mini')].map((b, k) => [b, avec[k][1], 'Ajouté', 'Ajouter']));
      o.suivi(suivis.map(([b, X, oui, non]) => {
        o.on(b, 'click', () => {
          if (b.disabled) return;
          // la bille ambre vers le panier (assets/yumi-vol-panier.js) part de ce clic : on ne désactive qu'après
          setTimeout(() => { b.disabled = true; });
          if (o.mesure) o.mesure('quiz_panier', { produit: X.handle });
          o.panier(X);
        });
        return { L: X, etat: dans => {
          b.classList.toggle('ok', dans); b.disabled = dans;
          b.innerHTML = dans ? `<i class="co">${CHECK}</i><span>${esc(oui)}</span>` : `${PANIER}<span>${esc(non)}</span>`;
        } };
      }));
      // recommencer (client, 09/10/2026) : un lien discret sous « Voir la fiche », retour à la première question
      o.on(el.querySelector('.refaire'), 'click', () => {
        if (verrou) return;
        o.suivi(null);
        rep = {};
        question(valables()[0]);
      });
      plus(rm ? 0 : 450, () => { el.querySelectorAll('li').forEach((li, k) => plus(rm ? 0 : k * 160, () => li.classList.add('on'))); el.querySelector('.yu').classList.add('vu'); });
    }

    depart();
  }

  /* ---------- boutique : le montage ---------- */
  const ctx = {
    later: (ms, fn) => setTimeout(fn, ms),
    on: (el, ev, fn) => el.addEventListener(ev, fn),
    tween: (ms, fn, ease) => {
      const t0 = performance.now();
      const pas = now => { const k = Math.min(1, (now - t0) / ms); fn(ease ? ease(k) : k); if (k < 1) requestAnimationFrame(pas); };
      requestAnimationFrame(pas);
    }
  };
  function charger(src) {
    return new Promise((ok, ko) => { const s = document.createElement('script'); s.src = src; s.onload = ok; s.onerror = ko; document.head.append(s); });
  }
  function monter(sec) {
    if (sec.dataset.ycQuizPret) return;
    sec.dataset.ycQuizPret = '1';
    const id = sec.dataset.ycQuiz;
    let live;
    try { live = JSON.parse(sec.querySelector('[data-yc-quiz-donnees]').textContent); } catch (e) { return; }
    charger(sec.dataset.donnees).then(() => {
      const DATA = window.YCQ_DONNEES && window.YCQ_DONNEES[id];
      if (!DATA) return;
      const M = moteur(DATA), par = {};
      (live.produits || []).forEach(p => { par[p.handle] = p; });
      // seulement les produits qu'on peut acheter tout de suite (lu en direct par le snippet, règle yc-proposable)
      // ses teintes aussi : prix, photo, variante et disponibilité de chaque couleur, lus en direct ; une teinte que le
      // snippet n'a pas rendue n'est pas proposable
      const P = DATA.produits.filter(L => par[L.handle] && par[L.handle].proposable).map(L => {
        const X = Object.assign({}, L, par[L.handle]);
        if (L.teintes) {
          const vif = {};
          (par[L.handle].teintes || []).forEach(t => { vif[t.handle] = t; });
          X.teintes = L.teintes.map(t => Object.assign({}, t, vif[t.h] || { proposable: false }));
        }
        return X;
      });
      if (P.length < 2) { sec.hidden = true; return; }
      // le bouton du résultat suit le vrai panier : relu à l'affichage, après chaque changement du panier (l'événement
      // standard que tout le thème émet) et au retour en arrière
      let suivi = null;   // [{ L, etat }] : un par bouton du résultat
      const lire = () => {
        if (!suivi) return;
        const s = suivi;
        fetch(live.lire || '/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(r => (r.ok ? r.json() : null))
          .then(p => { if (p && suivi === s) s.forEach(x => x.etat((p.items || []).some(i => String(i.variant_id) === String(x.L.variante)))); })
          .catch(() => {});
      };
      import('@shopify/events')
        .then(m => document.addEventListener(m.StandardEvents.cartLinesUpdate, ev => {
          (ev.promise ? ev.promise.catch(() => {}) : Promise.resolve()).then(lire);
        }))
        .catch(() => {});
      window.addEventListener('pageshow', e => { if (e.persisted) lire(); });
      const o = Object.assign({}, ctx, {
        mesure: (nom, p) => mesurer(id, nom, p),
        produits: P,
        courant: live.courant,
        // les images de Yumi vivent dans Fichiers, sous le nom « quiz-<nom du fichier> »
        image: p => (/^(https?:)?\/\//.test(p) ? p : live.fichiers + 'quiz-' + p.split('/').pop()),
        suivi: liste => { suivi = liste && liste.length ? liste : null; lire(); },
        // l'ajout passe par le même chemin que tous les boutons de la boutique : un formulaire yc-add-form intercepté
        // par layout/theme.liquid (ajout AJAX, volet du panier)
        panier: L => {
          const f = document.createElement('form');
          f.action = live.panier || '/cart/add';
          f.method = 'post';
          f.className = 'yc-add-form';
          f.hidden = true;
          f.innerHTML = '<input type="hidden" name="id" value="' + L.variante + '"><input type="hidden" name="quantity" value="' + (L.moq > 1 ? L.moq : 1) + '"><button type="submit" ' + (L.limites || '') + '></button>';
          sec.append(f);
          if (f.requestSubmit) f.requestSubmit(); else f.submit();
          setTimeout(() => { f.remove(); lire(); }, 4000);   // filet : un ajout refusé (plafond atteint) ne laisse rien de faux
        }
      });
      const seo = sec.querySelector('.yc-quiz__seo');
      if (seo) seo.hidden = true;
      carte(sec.querySelector('[data-yc-quiz-scene]'), M, o);
      // un clic sur un résultat (ligne du classement, photo, nom, « Voir la fiche ») : la visite de la fiche est comptée
      sec.addEventListener('click', ev => {
        const a = ev.target.closest && ev.target.closest('.ql2 a[href*="/products/"]');
        if (a) mesurer(id, 'quiz_clic_produit', { produit: (a.getAttribute('href').split('/products/')[1] || '').split(/[?#]/)[0] });
      }, true);
    }).catch(() => {});
  }
  window.YCQ = { moteur, carte };
  const tous = () => document.querySelectorAll('[data-yc-quiz]').forEach(sec => {
    if (!('IntersectionObserver' in window)) { monter(sec); return; }
    const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); monter(sec); } }, { rootMargin: '300px 0px' });
    io.observe(sec);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tous); else tous();

  /* ---------- style (préfixe ql2-, couleurs fixées par .yc-quiz dans snippets/yc-quiz.liquid) ---------- */
  if (!document.getElementById('ql2-css')) {
    const st = document.createElement('style');
    st.id = 'ql2-css';
    st.textContent = `
.ql2{position:relative;min-height:100%;padding:14px 14px 16px;display:flex;flex-direction:column;gap:10px;background-color:#faf6ef;background-image:radial-gradient(circle,rgba(102,60,31,.11) 1px,transparent 1.6px);background-size:18px 18px}
.ql2-haut{position:relative}
.ql2-sort{animation:ql2Out .17s cubic-bezier(.5,0,.75,0) forwards}
@keyframes ql2In{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:none}}
@keyframes ql2Out{to{opacity:0;transform:translateY(-10px)}}
@keyframes ql2Pop{0%{transform:scale(0)}70%{transform:scale(1.15)}100%{transform:scale(1)}}
@keyframes ql2Saut{0%,100%{translate:0 0}40%{translate:0 -8%}}
.ql2-depart{display:flex;flex-direction:column;align-items:center;text-align:center;gap:9px;padding:14px 4px 4px;animation:ql2In .4s cubic-bezier(.2,.9,.25,1) backwards}
.ql2-depart .yu{width:120px;height:auto;filter:drop-shadow(0 10px 12px rgba(43,32,19,.18))}
.ql2-depart .sur{font-size:10.5px;font-weight:900;letter-spacing:.15em;text-transform:uppercase;color:var(--faded)}
.ql2-depart h5{margin:0;font-size:27px;line-height:1.08;font-weight:900;letter-spacing:-.015em;color:var(--heading)}
.ql2-depart h5 span{display:block;color:var(--primary)}
.ql2-depart p{margin:0;font-size:16px;line-height:1.35;font-weight:800;color:var(--muted);max-width:24ch}
.ql2-go{margin-top:6px;font:inherit;font-weight:900;font-size:16px;letter-spacing:.02em;color:var(--dark);background:var(--primary);border:0;border-radius:999px;padding:13px 34px;cursor:pointer;box-shadow:0 10px 20px -8px rgba(181,114,30,.9);transition:transform .2s,background .2s}
.ql2-go:hover{background:var(--primary-hover);transform:translateY(-2px)}
.ql2-go:active{transform:scale(.97)}
.ql2-depart .vitrine{display:flex;gap:6px;justify-content:center;flex-wrap:wrap;margin-top:12px}
.ql2-depart .vitrine span{width:46px;height:46px;border-radius:12px;background:#fff;border:1px solid var(--border);display:grid;place-items:center;box-shadow:0 6px 12px -10px rgba(43,32,19,.6)}
.ql2-depart .vitrine img{width:86%;height:86%;object-fit:contain}
.ql2-prog{flex:none;animation:ql2In .35s cubic-bezier(.2,.9,.25,1) backwards}
.ql2-barre{position:relative;height:10px;border-radius:999px;background:#ece2d2;overflow:hidden}
.ql2-barre i{position:absolute;inset:0;border-radius:999px;background:linear-gradient(90deg,#f3b45e,#e8962e);transform-origin:left;transform:scaleX(.2);transition:transform .55s cubic-bezier(.2,.9,.25,1)}
.ql2-mots{display:grid;margin-top:2px;align-items:center}
.ql2-mots .dep{display:flex;justify-content:center;color:var(--primary);font-size:13px}
.ql2-mots button{font:inherit;font-size:11.5px;font-weight:800;color:var(--faint);background:none;border:0;padding:7px 0 6px;text-align:center;white-space:nowrap;cursor:default;border-radius:8px;-webkit-tap-highlight-color:transparent}
.ql2-mots button[hidden]{display:none}
.ql2-mots.serre button{font-size:10.5px;letter-spacing:-.01em}
.ql2-mots button.fait{color:var(--heading);cursor:pointer;text-decoration:underline;text-decoration-style:dotted;text-decoration-color:var(--primary);text-decoration-thickness:2px;text-underline-offset:4px}
.ql2-mots button.fait:hover,.ql2-mots button.fait:focus-visible{color:var(--primary-deep);background:#fff1dc;text-decoration-style:solid}
.ql2-mots button.ici{color:var(--primary-deep);font-weight:900}
.ql2-etape{animation:ql2In .3s cubic-bezier(.2,.9,.25,1) backwards}
.ql2-titre{margin:2px 0 8px;font-size:21px;line-height:1.15;font-weight:900;letter-spacing:-.01em;color:var(--heading)}
.ql2-cartes{display:grid;grid-template-columns:repeat(var(--n),minmax(0,1fr));gap:8px}
.ql2-carte{position:relative;font:inherit;color:inherit;cursor:pointer;background:#fffdf9;border:2px solid var(--border);border-radius:16px;padding:6px 6px 9px;display:flex;flex-direction:column;align-items:stretch;gap:6px;text-align:center;box-shadow:0 1px 2px rgba(43,32,19,.05),0 12px 22px -14px rgba(43,32,19,.35);transition:transform .25s cubic-bezier(.2,.9,.25,1),box-shadow .25s,border-color .2s,opacity .2s;animation:ql2In .34s cubic-bezier(.2,.9,.25,1) backwards}
.ql2-carte .vis{position:relative;display:block;aspect-ratio:1/1;border-radius:11px;overflow:hidden;background:radial-gradient(120% 90% at 50% 100%,#f6dcb4 0,#f7eddc 55%,#fbf4e8 100%)}
.ql2-carte .vis img{position:absolute;left:50%;bottom:5%;width:86%;height:86%;object-fit:contain;object-position:50% 100%;transform:translateX(-50%) scale(var(--s,1)) scaleX(var(--m,1));transform-origin:50% 100%;transition:transform .35s cubic-bezier(.3,1.5,.5,1)}
.ql2-carte .vis img.tete{width:70%;height:70%;bottom:2%}
.ql2-carte .tx{display:block}
.ql2-carte b{display:block;font-size:14.5px;font-weight:900;color:var(--heading);line-height:1.15}
.ql2-carte small{display:block;margin-top:2px;font-size:11px;font-weight:700;color:var(--faded);line-height:1.2}
.ql2-cartes.n4{gap:6px}
.ql2-cartes.n2{width:68%;margin:0 auto}
.ql2-cartes.n4 .ql2-carte{padding:5px 5px 8px;border-radius:14px}
.ql2-cartes.n4 b{font-size:12.5px}
/* 5 réponses ou plus, sur une seule rangée : cartes étroites (≈ 60 px à 390 px). Les mots longs se coupent au lieu de déborder (client 23/10/2026 : libellés coupés). */
.ql2-cartes.n5 .ql2-carte{padding:4px 3px 7px}
.ql2-cartes.n5 b{font-size:11px;line-height:1.12;overflow-wrap:anywhere;hyphens:auto}
.ql2-carte .ok{position:absolute;top:-8px;right:-8px;z-index:5;width:26px;height:26px;border-radius:50%;background:var(--primary);color:#fff;display:grid;place-items:center;box-shadow:0 3px 8px -2px rgba(181,114,30,.55);transform:scale(0)}
.ql2-carte .ok svg{width:15px;height:15px}
@media (hover:hover){.ql2-cartes:not(.verrou) .ql2-carte:hover{transform:translateY(-4px);border-color:var(--chip);box-shadow:0 2px 4px rgba(43,32,19,.06),0 18px 28px -16px rgba(43,32,19,.45)}}
.ql2-cartes:not(.verrou) .ql2-carte:active{transform:scale(.97)}
.ql2-cartes.verrou{pointer-events:none}
.ql2-carte.choisie{border-color:var(--primary);background:#fff8ec;box-shadow:0 0 0 4px rgba(232,150,46,.2),0 18px 28px -16px rgba(43,32,19,.45)}
.ql2-carte.choisie .ok{animation:ql2Pop .32s cubic-bezier(.3,1.6,.5,1) forwards}
.ql2-carte.choisie.deja .ok{animation:none;transform:scale(1)}
.ql2-carte.choisie:not(.deja) .vis img{animation:ql2Saut .45s cubic-bezier(.3,1.4,.5,1)}
.ql2-cartes.verrou .ql2-carte:not(.choisie){opacity:.55}
.ql2-cl{flex:none;margin-top:6px;animation:ql2In .35s .1s cubic-bezier(.2,.9,.25,1) backwards}
.ql2-liste{position:relative}
.ql2-lg{position:absolute;left:0;right:0;top:0;height:46px;display:grid;grid-template-columns:38px minmax(0,1fr) 50px;gap:10px;align-items:center;background:#fffdf9;border:1px solid var(--border);border-radius:12px;padding:0 10px 0 5px;transition:transform .55s cubic-bezier(.3,1.2,.5,1),opacity .4s,filter .4s,border-color .3s,box-shadow .3s}
a.ql2-lg{color:inherit;text-decoration:none}
.ql2:not(.fini) .ql2-lg{pointer-events:none}
.ql2.fini .ql2-lg:not(.cache){cursor:pointer}
.ql2.fini .ql2-lg:not(.cache):hover,.ql2.fini .ql2-lg:not(.cache):focus-visible{border-color:var(--primary)}
.ql2-fin .nom a{color:inherit;text-decoration:underline;text-decoration-color:var(--primary);text-decoration-thickness:2px;text-underline-offset:4px}
.ql2-fin .nom a:hover{color:var(--primary-deep)}
.ql2-fin a.ph{text-decoration:none}
.ql2-lg.cache{opacity:0;pointer-events:none;visibility:hidden;transition:transform .55s cubic-bezier(.3,1.2,.5,1),opacity .3s,visibility 0s .3s}
.ql2-lg .ph{width:36px;height:36px;border-radius:9px;background:#fff;display:grid;place-items:center}
.ql2-lg .ph img{width:92%;height:92%;object-fit:contain}
.ql2-lg .n{font-weight:900;font-size:13px;color:var(--heading);line-height:1.1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.ql2-lg .j{position:relative;height:7px;background:var(--field);border-radius:4px;margin-top:5px;overflow:hidden}
.ql2-lg .j i{position:absolute;inset:0;border-radius:4px;background:linear-gradient(90deg,#f3b45e,#e8962e);transform-origin:left;transform:scaleX(0);transition:transform .5s cubic-bezier(.3,1.1,.5,1)}
.ql2-lg .pc{text-align:right;font-weight:900;font-size:16px;color:var(--heading);font-variant-numeric:tabular-nums}
.ql2-lg.top{border:2px solid var(--primary);box-shadow:0 10px 18px -12px rgba(181,114,30,.8);z-index:2}
.ql2-lg.top .pc{color:var(--primary-deep)}
.ql2-lg.out{opacity:.5;filter:grayscale(1)}
.ql2-fin{background:#fffdf9;border:1px solid var(--border);border-radius:16px;box-shadow:0 1px 2px rgba(43,32,19,.05),0 16px 32px -14px rgba(43,32,19,.3);padding:12px 14px 10px;display:flex;flex-direction:column;gap:8px;animation:ql2In .4s cubic-bezier(.2,.9,.25,1) backwards}
.ql2-fin .sur{font-size:10px;font-weight:900;letter-spacing:.14em;text-transform:uppercase;color:var(--primary-deep);text-align:center}
.ql2-fin .vitre{display:flex;justify-content:center;align-items:center;gap:12px}
.ql2-fin .cote{display:flex;flex-direction:column;align-items:stretch;gap:5px;flex:none}
.ql2-fin .ph{width:clamp(126px,34vw,148px);aspect-ratio:1;flex:none;background:#fff;border-radius:14px;border:1px solid #f1e7d7;display:grid;place-items:center}
.ql2-fin .ph img{width:90%;height:90%;object-fit:contain}
.ql2-fin .yu{width:58px;flex:none;align-self:center;opacity:0;transform:scale(.4) rotate(10deg);transform-origin:50% 100%;filter:drop-shadow(0 6px 8px rgba(43,32,19,.25));transition:opacity .2s,transform .45s cubic-bezier(.3,1.5,.5,1)}
.ql2-fin .yu.vu{opacity:1;transform:none}
.ql2-fin .nom{display:block;font-size:22px;font-weight:900;color:var(--heading);line-height:1.1;text-align:center;margin-top:2px}
.ql2-fin .ligne{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:6px 12px}
.ql2-fin .score{display:inline-block;background:var(--green-bg);border:1px solid var(--green-border);color:var(--green);border-radius:999px;padding:3px 11px;font-size:13px;font-weight:800}
.ql2-fin .score b{font-size:15px;font-weight:900}
.ql2-fin .fiche{display:inline-flex;align-items:center;justify-content:center;gap:4px;font-size:12px;font-weight:900;color:var(--primary-deep);text-decoration:none;white-space:nowrap;background:#fff;border:1.5px solid var(--chip);border-radius:999px;padding:5px 9px;min-height:30px;box-sizing:border-box}
.ql2-fin .fiche:hover{color:var(--heading);border-color:var(--primary)}
.ql2-fin .refaire{display:inline-flex;align-items:center;justify-content:center;gap:4px;font:inherit;font-size:11.5px;font-weight:800;color:var(--faded);background:none;border:0;border-radius:999px;padding:3px 6px;min-height:26px;cursor:pointer;white-space:nowrap;-webkit-tap-highlight-color:transparent}
.ql2-fin .refaire:hover,.ql2-fin .refaire:focus-visible{color:var(--primary-deep);background:#fff1dc}
.ql2-fin ul{list-style:none;margin:2px 0 0;padding:10px 2px 0;border-top:1px dashed var(--border);display:grid;gap:7px}
.ql2-fin li{display:flex;align-items:center;gap:9px;font-size:15px;font-weight:900;color:var(--heading);line-height:1.25;white-space:nowrap;opacity:0;transform:translateX(-8px);transition:opacity .25s,transform .3s cubic-bezier(.2,.9,.25,1)}
.ql2-fin li span{overflow:hidden;text-overflow:ellipsis}
.ql2-fin li.on{opacity:1;transform:none}
.ql2 .co{flex:none;width:22px;height:22px;border-radius:50%;background:var(--primary);color:#fff;display:inline-grid;place-items:center;font-style:normal}
.ql2 .co svg{width:13px;height:13px}
.ql2-fin .prix{display:flex;align-items:baseline;justify-content:center;flex-wrap:wrap;gap:4px 10px;margin-top:4px}
.ql2-fin .prix b{font-size:22px;font-weight:900;color:var(--heading)}
.ql2-fin .prix s{font-size:14px;font-weight:700;color:var(--faded)}
.ql2-fin .eco{align-self:center;font-size:13px;font-weight:900;color:#fff;background:var(--red);border-radius:6px;padding:2px 7px}
.ql2-panier{display:flex;align-items:center;justify-content:center;gap:8px;font:inherit;font-weight:900;font-size:15.5px;color:var(--dark);background:var(--primary);border:0;border-radius:999px;padding:13px 16px;cursor:pointer;box-shadow:0 8px 18px -8px rgba(181,114,30,.85);transition:transform .2s,background .2s}
.ql2-panier:hover{background:var(--primary-hover);transform:translateY(-1px)}
.ql2-panier:disabled{cursor:default}
.ql2-panier.ok{background:var(--green);color:#fff;box-shadow:none;cursor:default;transform:none}
.ql2-panier.ok .co{background:#fff;color:var(--green)}
.ql2 .pastille{flex:none;display:inline-block;width:13px;height:13px;border-radius:50%;border:1px solid rgba(43,32,19,.28);box-shadow:inset 0 -2px 3px rgba(0,0,0,.12)}
.ql2-fin .teinte{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:2px 6px;margin-top:-5px;font-size:13.5px;font-weight:800;color:var(--muted)}
.ql2-pasen{display:block;margin-top:8px;text-align:center;font-size:12.5px;font-weight:700;color:var(--faded)}
.ql2-lg .n .mq{margin-left:6px;font-size:11.5px;font-weight:700;color:var(--faded)}
.ql2-lg .n .mq:empty{display:none}
.ql2-fin .teinte small{font-size:12px;font-weight:700;color:var(--faded)}
.ql2-avec{display:grid;gap:6px;padding-top:9px;border-top:1px dashed var(--border)}
.ql2-avec .t{font-size:10px;font-weight:900;letter-spacing:.14em;text-transform:uppercase;color:var(--primary-deep);text-align:center}
.ql2-av{display:grid;grid-template-columns:40px minmax(0,1fr) auto;align-items:center;gap:9px;background:#fff;border:1px solid var(--border);border-radius:12px;padding:4px 5px 4px 4px}
.ql2-av .vg{width:40px;height:40px;border-radius:9px;display:grid;place-items:center;background:#fff}
.ql2-av .vg img{width:92%;height:92%;object-fit:contain}
.ql2-av .n{display:grid;gap:1px;min-width:0;font-size:14px;font-weight:900;color:var(--heading);line-height:1.15}
.ql2-av .n .l{display:flex;align-items:center;gap:6px;min-width:0}
.ql2-av .n .l span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.ql2-av .n small{font-size:12.5px;font-weight:800;color:var(--muted);padding-left:19px}
.ql2-panier.mini{font-size:13px;padding:8px 12px;gap:5px;box-shadow:none;white-space:nowrap}
.ql2-panier.mini svg{width:15px;height:15px}
.ql2-panier.mini .co{width:18px;height:18px}
.ql2-prog.defile .ql2-mots{position:relative;display:flex;gap:2px;overflow-x:auto;overscroll-behavior-x:contain;scrollbar-width:none;-webkit-overflow-scrolling:touch;padding:0 calc(50% - 34px);-webkit-mask-image:linear-gradient(90deg,transparent 0,#000 22px,#000 calc(100% - 22px),transparent 100%);mask-image:linear-gradient(90deg,transparent 0,#000 22px,#000 calc(100% - 22px),transparent 100%)}
.ql2-prog.defile .ql2-mots::-webkit-scrollbar{display:none}
.ql2-prog.defile .ql2-mots .dep{flex:none;padding:0 8px}
.ql2-prog.defile .ql2-mots button{flex:none;padding:7px 9px 6px}
@media (max-width:380px){.ql2{padding:12px 12px 14px}.ql2-mots button{font-size:10.5px}.ql2-titre{font-size:19.5px}.ql2-carte b{font-size:13.5px}.ql2-cartes.n4 b{font-size:11.5px}.ql2-fin li{font-size:14px}}
@media (prefers-reduced-motion:reduce){.ql2 *{animation:none!important;transition:none!important}}
`;
    document.head.appendChild(st);
  }
})();
